import React from "react";

import ComponentTitle from "../../../components/ComponentTitle/ComponentTitle";

import slackIcon from "../../../resources/images/slack-img-1.png";
import wixIcon from "../../../resources/images/wix-img-1.png";
import wordpressIcon from "../../../resources/images/wordpress-img-1.png";
import squarspaceIcon from "../../../resources/images/squarspace-img-1.png";
import shopifyIcon from "../../../resources/images/shopify-img-1.png";
import salesforceIcon from "../../../resources/images/salesforce-img-1.png";
import integrationWindow from "../../../resources/images/integration-window.svg";

import {
  StyledContainer,
  StyledTitleContainer,
  StyledMainContainer,
  StyledLeftContainer,
  StyledRightContainer,
  StyledIconContainer,
  StyledInnerIcon,
  StyledImageWindowContainer,
} from "./KvaliIntegrationsStyle";

const KvaliIntegrations = () => {
  return (
    <StyledContainer>
      <StyledTitleContainer>
        <ComponentTitle value="Integrations" />
      </StyledTitleContainer>
      <StyledMainContainer>
        <StyledLeftContainer>
          <StyledIconContainer left="10%">
            <StyledInnerIcon src={slackIcon} alt="" />
          </StyledIconContainer>
          <StyledIconContainer top={"40px"} right={"0"}>
            <StyledInnerIcon src={wixIcon} alt="" />
          </StyledIconContainer>
          <StyledIconContainer bottom={"46%"} left={"39%"}>
            <StyledInnerIcon src={wordpressIcon} alt="" />
          </StyledIconContainer>
          <StyledIconContainer bottom={"200px"} left={"0"}>
            <StyledInnerIcon src={squarspaceIcon} alt="" />
          </StyledIconContainer>
          <StyledIconContainer bottom={"20%"} right={"12%"}>
            <StyledInnerIcon src={shopifyIcon} alt="" />
          </StyledIconContainer>
          <StyledIconContainer bottom={"0"} left={"20%"}>
            <StyledInnerIcon src={salesforceIcon} alt="" />
          </StyledIconContainer>
        </StyledLeftContainer>
        <StyledRightContainer>
          <StyledImageWindowContainer>
            <img src={integrationWindow} alt="" />
          </StyledImageWindowContainer>
        </StyledRightContainer>
      </StyledMainContainer>
    </StyledContainer>
  );
};

export default KvaliIntegrations;
